import React from "react";
import ReactDOM from "react-dom/client";
import SignupForm from "./routes/SignupForm";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));

const router = createBrowserRouter([
  {
    path: "/",
    element: <SignupForm />,
  },
  // {
  //   path: "/facebook",
  //   element: <SignupForm routePath="facebook" />,
  // },
  // {
  //   path: "/tiktok",
  //   element: <SignupForm routePath="tiktok"/>,
  // },
  // {
  //   path: "/youtube",
  //   element: <SignupForm routePath="youtube"/>,
  // },
  {
    path: "*",
    element: <p>The page you are looking for cannot be found.</p>,
  },
]);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
